export default {
  phoneStep: {
    title: 'Вход в личный кабинет',
    annotation:
      '<p>Ваш личный кабинет — полный контроль над сделкой и купленным объектом в режиме 24/7.</p>' +
      '<p>Здесь собрана вся информация по вашей сделке и объекту недвижимости.</p>' +
      '<p>Отслеживайте статус сделки, изучайте детали купленной квартиры, следите за ходом строительства.</p>' +
      '<p>В вашем распоряжении также каталог доступных квартир.</p>' +
      '<p>Следите за акциями и новостями компании и не упускайте выгодные предложения.',
    phoneNumber: 'Номер телефона',
    confirmPhone: 'Подтвердить номер',
    errors: {
      phoneIsEmpty: 'Введите номер телефона',
      phoneNotValid: 'Проверьте правильность номера',
      phoneNotExist: 'Указанного номера телефона не существует',
      tooManyRequestCode: 'Код можно запросить 1 раз в минуту',
    },
  },
  phoneConfirmStep: {
    title: 'Подтвердите Ваш номер телефона',
    repeatRequest: 'Повторный звонок',
    annotation: 'Сделайте звонок на номер \n',
    extraAnnotation: 'Система определит, что звонок пришел с указанного Вами номера телефона при регистрации и подтвердит данный номер телефона \n',
    renewConfirm: 'Запросить повторно ',
    goBack: 'Вернуться назад',
    errors: {
      codeNotValid: 'Код указан неверно',
      attemptsLimitReached: 'Количество попыток исчерпано, запросите код заново. Срок действия смс - 2 минуты',
      ttlLimitReached: 'Слишком много попыток на запрос отправки смс кода, попробуйте позже',
      tooFrequentRequestes: 'Слишком много запросов, попробуйте позже',
    },
    sms: {
      hint:
        'Если ваш мобильный оператор блокирует звонок или вызов не проходит (после звонка ничего не происходит), ' +
        'через 2 минуты, после попытки звонка, мы автоматически предложим вам подтвердить вход по СМС-коду.',
      getCode: 'Получить код по SMS',
      codeLabel: 'Код из SMS',
      renewCode: 'Запросить код повторно через',
      repeatCode: 'Отправить код повторно',
    },
  },
  nameStep: {
    title: 'Регистрация',
    annotation: 'Для быстрого бронирования и консультаций',
    name: 'Имя*',
    lastName: 'Фамилия*',
    patronymic: 'Отчество',
    birthDate: 'Дата рождения*',
    email: 'Электронная почта*',
    confirm: 'Зарегистрироваться',
    back: 'Вернуться назад',
    validity: 'Заполните обязательные поля, чтобы создать аккаунт',
    errors: {
      emailIsInvalid: 'Адрес электоронной почты указан в неверном формате',
      date: 'Обязательное поле',
    },
    descrText1: 'Важно указать действующую электронную почту и подтвердить её.',
    descrText2:
      'Проект договора, регистрация прав собственности и зарегистрированные документы будут доступны только при наличии электронной почты.',
    privacyPolicy: {
      text: 'Я даю согласие на ',
      link: 'обработку моих персональных данных'
    },
    promoOffer: {
      textStart: 'Я согласен(на) на предоставление мне ',
      textLink: 'информации и рекламных предложений',
      textEnd: ' ООО «Ак Барс Дом» путем направления сообщений в любом формате'
    },
  },
  emailConfirmStep: {
    title: 'Регистрация',
    annotation:
      'Код подтверждения выслан на указанную вами электронную почту. Если код не приходит, проверьте её на предыдущей странице.',
    label: 'Код из из письма',
    buttonText: 'Подтвердить почту',
    renewCode: 'Запросить повторно через ',
    repeatCode: 'Отправить повторно',
    goBack: 'Вернуться назад',
  },
  problemStep: {
    limitErrorCodeTitle: 'Проблемы со входом?',
    limitErrorCodeAnnotation: 'Свяжитесь с нашей службой поддержки \n для подтверждения личности',
    requestSupport: 'Связаться с поддержкой',
    goMain: 'На главную',
  },
  backgroundText: {
    titleStart: 'Добро \n пожаловать \n в ваш ',
    whatYouSearch: 'То, что вы искали',
    homeIsWhereWeAre: 'Дом там, \n где мы',
  },
};
